import { LinkIcon } from "lucide-react";

import { labelsMissingUrls } from "@/lib/resume-links";

/**
 * Asks for the profile URLs a resume text mentions but does not contain.
 * Renders nothing unless there is something only the user can supply.
 */
export function ResumeLinkWarning({ text }: { text: string }) {
  const missing = labelsMissingUrls(text);
  if (!missing.length) return null;

  return (
    <div className="flex gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3">
      <LinkIcon className="mt-0.5 size-4 shrink-0 text-amber-500" aria-hidden="true" />
      <p className="text-xs leading-relaxed text-muted-foreground">
        <span className="font-semibold text-foreground">
          {missing.join(" and ")} {missing.length > 1 ? "are" : "is"} named without an address.
        </span>{" "}
        Add the full link (linkedin.com/in/you) here or in the notes, or the tailored resume will
        show a dead label.
      </p>
    </div>
  );
}
